<!-- <div class="container">
    <label for="voices">Select a Voice:</label>
    <select id="voices" (change)="onVoiceChange($event.target.value)">
        <option *ngFor="let voice of voices" [value]="voice.name">{{ voice.name }}</option>
    </select>
</div> -->

<div>
    <p class="btn-video center-button btn-iframe" (click)="play()"><mat-icon>{{playIconText}}</mat-icon></p>
</div>